import React from "react";
import { Box, Divider } from "@mui/material";
import { BASE_CONSTANTS } from "constants/baseConstants";

export const CardActions = ({ children, alignLeft = false }) => {
  return (
    <>
      <Divider />

      <Box
        display="flex"
        alignItems="center"
        justifyContent={alignLeft ? "flex-start" : "flex-end"}
        gap={BASE_CONSTANTS.SPACING_SM}
        paddingX={BASE_CONSTANTS.PADDING_MD}
        paddingY={2}
        flexShrink={0}
      >
        {children}
      </Box>
    </>
  );
};
